import ApolloClient from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import { getAuthToken, authToken, getAuthTokenFromStorage, user_object } from './authToken';



const GRAPHQL_ENDPOINT =  "https://poall.herokuapp.com/v1/graphql";

let httpLink = new HttpLink({
    uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((a, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = authToken;
    console.log('x-hasura-role: '+ user_object?.product_plan.title)
    if (token && user_object) {        
        return {
            headers: {
                ...headers,
                authorization: `Bearer ${token}`,
                'x-hasura-role': user_object?.product_plan?.title
            },
        };
    }
    else {
        return {
            headers: {
                ...headers
            },
        };
    }
});

const errorHandler = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) =>
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );
    }
    if (networkError) {
        console.log(`[Network error]: ${networkError}`);
    }
});


// const errorLink = onError(
//     ({ graphQLErrors, networkError, operation, forward }) => {
//         if (graphQLErrors)
//             graphQLErrors.map(({ message, extensions }) => {
//                 switch (extensions.code) {
//                     case "invalid-jwt":
//                         // refetch the jwt
//                         const oldHeaders = operation.getContext().headers;
//                         const token = getAuthToken();
//                         operation.setContext({
//                             headers: {
//                                 ...oldHeaders,
//                                 authorization: `Bearer ${token}`
//                             }
//                         });
//                         // retry the request, returning the new observable
//                         return forward(operation);
//                         break;
//                     default:
//                         // default case
//                         console.log(extensions.code);
//                 }
//             });
//         if (networkError) {
//             console.log(`[Network error]: ${networkError}`);
//         }
//     }
// );


export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
    // onError: errorHandler
});